import { z } from "zod";
import { type UserGamificationStats } from "../../firestore";
import { type FunctionObjectReturn } from "../utils";

/** Empty body — start-without-import is authenticated via callable UID. */
export const FreshStartGamificationBodySchema = z.preprocess((value) => value ?? {}, z.object({}).strict());

export type FreshStartGamificationBody = z.infer<typeof FreshStartGamificationBodySchema>;

export type FreshStartGamificationPayload = {
  /** True when a new stats document was created. */
  created: boolean;
  /** True when existing stats were reset to a no-import baseline. */
  replaced: boolean;
  /** True when `freshStartedAt` was already set (idempotent no-op). */
  alreadyStarted: boolean;
  stats: UserGamificationStats;
};

export type FreshStartGamificationResponse = FunctionObjectReturn<FreshStartGamificationPayload>;
